// extracted by mini-css-extract-plugin
export default {"title":"rpmXN3Dw","subtitle":"foukFOmP","text":"Rcd2EahA","stretched":"jE2tA8QT","cnt":"J5JRil19","icon":"VQktI3SJ","wrapper":"kMi2JJVH","action":"zwPilOIV"};